import React, { useState } from "react"
import "./tabs.css"
import { classNames } from "../../utils"
import { navigate } from "gatsby"
import { useBasePath } from "../../hooks"

export const Tabs = ({ tabs }) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0].id)

  return (
    <>
      <div className="tabs">
        <ul>
          {tabs.map((tab) => (
            <li
              className={`cursor-pointer ${classNames({
                "tab-selected": tab.id === selectedTab,
              })}`}
              onClick={() => setSelectedTab(tab.id)}
              key={`tab-${tab.id}`}
            >
              {tab.label}
            </li>
          ))}
        </ul>
      </div>
      <div>{tabs.find((tab) => tab.id === selectedTab).render()}</div>
    </>
  )
}

export const TabsURLManaged = ({ tabs, location }) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0].id)
  const basePath = useBasePath()
  React.useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tabParam = params.get("tab")
    if(tabParam && tabs.some(({id}) => tabParam === id)){
      setSelectedTab(tabParam)
    }
  },[])

  const onClickTab = (id) => {
    setSelectedTab(id)
    const pathname = location.pathname.replace(new RegExp(`^${basePath}`), '')
    navigate(`${pathname}?tab=${id}`, {replace: false})
  }

  return (
    <>
      <div className="tabs">
        <ul>
          {tabs.map((tab) => (
            <li
              className={`cursor-pointer ${classNames({
                "tab-selected": tab.id === selectedTab,
              })}`}
              onClick={() => onClickTab(tab.id)}
              key={`tab-${tab.id}`}
            >
              {tab.label}
            </li>
          ))}
        </ul>
      </div>
      <div>{tabs.find((tab) => tab.id === selectedTab).render()}</div>
    </>
  )
}



